export const HOVER_ANIMATION_DURATION = 0.4;

export const IMAGE_BRIGHTNESS = {
  normal: 0.6,
  hover: 0.4,
};

export const TEXTS = {
  miraMas: "MIRA MÁS",
  ultimasUnidades: "ÚLTIMAS UNIDADES",
};














